<template>
  <div class="Air-por-div" style="100%">
    <el-row>
      <div class="protd-list" id="proid">
        <el-col :span="12" v-for="(item, index) in showList"
            :key="index">
          <div class="protd-list-corlor" >
            <div >
              <img  v-lazy="item.url" style="width: 100%" />
            </div>
            <div class="protd-biaoti"><span style="font-weight: bold;">{{item.span}}</span><br>{{ item.title }}</div>
            <div class="protd-desc">{{ item.desc }}</div>
          </div>
        </el-col>
      </div>
    </el-row>
    <div class="protedian-jiantou">
      <div style=" cursor: pointer" @click="dianji(1)">
        <img class="arrow_pic" src="../assets/images/icon/air-bai-zjt.png" />
      </div>
      <div style=" cursor: pointer" @click="dianji(2)">
        <img class="arrow_pic" src="../assets/images/icon/air-bai-yjt.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list'],
  computed: {
    showList: {
      get () {
        let list = this.list
        let res = []
        if (list.length > 1) {
          res.push(list[this.showIndexs[0]])
          res.push(list[this.showIndexs[1]])
        }
        return res
      }
    }
  },
  data: () => ({
    showIndexs: [0, 1]
  }),
  methods: {
    dianji (type) {
      if (type === 1) {
        if (this.showIndexs[0] === 0) {
          this.$message.closeAll()
          this.$message('已经是第一张啦！',1)
          return false
        }
        this.showIndexs = this.showIndexs.map((element) => element - 1)
      } else {
        if (this.showIndexs[1] + 1 === this.list.length) {
          this.$message.closeAll()
          this.$message('已经是第最后一张啦！',1)
          return false
        }
        this.showIndexs = this.showIndexs.map((element) => element + 1)
      }
    }
  }
}
</script>

<style scoped>
.body{width: 100%;}
/* ------------- mobile端样式(屏幕小于960px) ------------- */
@media only screen and (max-width: 960px) {
  /* 箭头图标 */
  .protedian-jiantou {position: absolute;top: 25%;width: 100%;}
  .protd-list-corlor { width: 65%;}
  .protd-biaoti { font-size: 46px;}
  img[lazy="loading"] {
  width: 100%;
  height: 250px;
  /* margin-left: 30%;
  margin-top: -2%; */
}
  
}
/* ------------- pc端样式(屏幕大于960px) ------------- */
@media only screen and (min-width: 960px) {
  /* 箭头图标 */
  .protedian-jiantou {position: absolute;bottom: 22px;width: 100%;
  
  }
  .protd-list-corlor { width: 50%;}
  .protd-biaoti { font-size: 20px;}

  img[lazy="loading"] {
  width: 100%;
  height: 200px;
  /* margin-left: 30%;
  margin-top: -2%; */
}
}
/* 第三部分  产品 */
.arrow_pic{
  width: 60px;
  height: 162px;
}
.Air-por-div {
  position: relative;
}
.protd-list {
  display: flex;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
  padding-top: 3%;
}
.protd-list-corlor {
  margin: 0 auto;
}
.protedian-jiantou {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;
    margin: auto;
    text-align: center;
    position: left;
    position: absolute;
    left: 0;
    right: 0;
}
.protd-biaoti {
  width: 100%;
  margin-bottom:-40px;
  margin-top: 20px;
  color: #30335C;
  letter-spacing: 1px;
}
.protd-desc {
  font-size: 25px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom:-25%;
  margin-top: 15%;
}


</style>



// WEBPACK FOOTER //
// src/components/AirProTDTransverse.vue